import React from 'react'
import {
  VerticalTimeline,
  VerticalTimelineElement
} from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
// const isMobile = browserCheck.isMobile

export const timelineContent = [
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>1992</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Direktzahlungen an Bauern
          </h4>
          <p>
            Unter internationalem Druck werden Preisgarantien für einzelne
            Produkte ersetzt durch Direktzahlungen an Bauern, die verknüpft sind
            mit der Förderung nachhaltiger Landwirtschaft.
          </p>
          <div className='quote'>
            <p>
              «Die Idee einer ökologisch-sozialen Erneuerung der Wirtschaft lag
              in der Luft. Die paar Hundert Biobauern sollten anfangs nicht von
              den Direktzahlungen profitieren. ‹Sie erhalten in der
              Direktvermarktung ja höhere Preise›, meinte das Bundesamt für
              Landwirtschaft. Letztendlich erhielten Biobauern aber höhere
              Direktzahlungen als integriert wirtschaftende Bauern.»
            </p>
            <div>
              <img
                className='ui medium circular image'
                src={require('../../images/urs-niggli.png')}
              />
              <span>Urs Niggli</span>
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>1996</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Verfassungsartikel 104
          </h4>
          <p>
            Der neue Artikel schreibt nachhaltige Landwirtschaft in der
            Verfassung fest - aber erst die Verknüpfung mit der Ökologie
            verhilft ihm zum Abstimmungserfolg.
          </p>
          <div className='quote'>
            <p>
              «Damit war die Schweizer Politik der EU-Agrarpolitik weit voraus.
              Erst heute verankert die EU die nachhaltige Landwirtschaft und
              Ernährung in der Agrarpolitik. Die darin enthaltenen Ziele, wie
              eine Halbierung von Pestiziden und Dünger und ein Anteil von 25
              Prozent Bio, stellen die Schweiz wiederum in den Schatten.»
            </p>
            <div>
              <img
                className='ui medium circular image'
                src={require('../../images/urs-niggli.png')}
              />
              <span>Urs Niggli</span>
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>1999</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Ökologischer Leistungsnachweis
          </h4>
          <p>
            Ein Bauer muss die Vorgaben des ÖLN erfüllen, um Direktzahlungen zu
            erhalten.
          </p>
          <div className='quote'>
            <p>
              «Der ÖLN war eine weltweite Pionierleistung. Man sieht, dass ein
              kleines und reiches Land wie die Schweiz viel flexibler und
              mutiger sein kann. Die EU diskutiert heute ein ähnliches Konzept.»
            </p>
            <div>
              <img
                className='ui medium circular image'
                src={require('../../images/urs-niggli.png')}
              />
              <span>Urs Niggli</span>
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>2007</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Exportsubventionen abgeschafft
          </h4>
          <p>
            Der Staat zahlt keine Subventionen mehr für die Ausfuhr
            landwirtschaftlicher Produkte.
          </p>
          <div className='quote'>
            <p>
              «Ein längst fälliger Schritt. Er hat die Handelsbeziehungen mit
              den Entwicklungsländern ein klein wenig gerechter gemacht.»
            </p>
            <div>
              <img
                className='ui medium circular image'
                src={require('../../images/urs-niggli.png')}
              />
              <span>Urs Niggli</span>
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>2014</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Direktzahlungen für Nachhaltigkeit
          </h4>
          <p>
            Die Zahlungen an Bauern orientieren sich noch stärker an den Zielen
            von Verfassungsartikel 104. Gefördert werden etwa emissionsarme
            Spritzgeräte oder der Anbau von Sonnenblumen und Raps ohne Fungizide
            und Insektizide.
          </p>
          <div className='quote'>
            <p>
              «Das waren zaghafte Schritte in die richtige Richtung. Die
              Schweizer Landwirtschaft hat nur eine Chance, nämlich höchste
              Qualität, schonender Umgang mit den natürlichen Ressourcen und der
              artgerechte Umgang mit Tieren.»
            </p>
            <div>
              <img
                className='ui medium circular image'
                src={require('../../images/urs-niggli.png')}
              />
              <span>Urs Niggli</span>
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>2017</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Verfassungsartikel zur Versorgungssicherheit
          </h4>
          <p>
            Auf Initiative des Bauernverbandes wird mit Artikel 104a die sichere
            Versorgung der Schweiz mit Lebensmitteln in die Bundesverfassung
            aufgenommen.
          </p>
          <h4
            className='vertical-timeline-element-subtitle'
            style={{ marginTop: '1rem' }}
          >
            «Aktionsplan Pflanzenschutz»
          </h4>
          <p>
            Der Bundesrat legt einen Rahmen fest um das Risiko beim Einsatz von
            Pestiziden zu reduzieren und nach nachhaltigen Methoden zu forschen.
          </p>
          <div className='quote'>
            <p>
              «Artikel 104a hat mehr der Profilierung des Bauernverbands als
              einer echten Veränderung der Landwirtschaft genutzt.
            </p>
            <p>
              Ich habe einen nationalen Aktionsplan Pflanzenschutz als Mitglied
              des wissenschaftlichen Beirats der deutschen Regierung erlebt. Die
              Aktionspläne in allen europäischen Ländern waren sehr zögerlich,
              keine mutigen Schritte. So auch in der Schweiz.»
            </p>
            <div>
              <img
                className='ui medium circular image'
                src={require('../../images/urs-niggli.png')}
              />
              <span>Urs Niggli</span>
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>2018</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Verschärfte Zulassung von Pestiziden
          </h4>
          <p>
            Die Verfahren zur Zulassung von Pflanzenschutzmitteln werden
            überprüft. Damit reagiert die Regierung auf den Druck aus der
            Bevölkerung, den Einsatz von Pestiziden zu reduzieren – wie die
            Trinkwasserinitiative und Pestizidinitiative zeigen, die 2018
            zustande kommen.
          </p>
          <div className='quote'>
            <p>
              «Als Laie würde ich mich auch fragen; ‹Warum lassen wir die
              Pestizide nicht einfach im Giftschrank?› Man vergisst aber leicht,
              dass Pflanzenschutzmittel für den Ertrag, die jahreszeitliche
              Stabilität der Ernte und die schöne Qualität der Produkte
              entscheidend sind. 30 bis 50 Prozent der Ernte weltweit hängt von
              einem guten Pflanzenschutz ab. Deswegen ist ein Ausstieg eine
              grosse Sache.»
            </p>
            <div>
              <img
                className='ui medium circular image'
                src={require('../../images/urs-niggli.png')}
              />
              <span>Urs Niggli</span>
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>2019</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Chlorothalonil verboten
          </h4>
          <p>
            Nach heftiger öffentlicher Diskussion um das umstrittene Fungizid,
            das möglicherweise krebserregend ist, wird Chlorothalonil verboten.
          </p>
          <h4
            className='vertical-timeline-element-subtitle'
            style={{ marginTop: '1rem' }}
          >
            Reduktion von Herbiziden
          </h4>
          <p>
            Der Bund fördert den reduzierten Einsatz von Giften bei der
            Bekämpfung von Unkraut im Ackerbau.
          </p>
          <div className='quote'>
            <p>
              «Man hat offenbar falsch eingeschätzt, wie lange
              Chlorothalonil-Fungizide in der Umwelt erhalten bleiben. Das
              zeigt, wie schwierig das Umweltverhalten oft einzuschätzen ist.
            </p>
            <p>
              Wir könnten auf Herbizide, also Unkrautvernichtungsmittel,
              vollständig verzichten. Biobauern haben gezeigt, dass es sehr gut
              ohne geht.»
            </p>
            <div>
              <img
                className='ui medium circular image'
                src={require('../../images/urs-niggli.png')}
              />
              <span>Urs Niggli</span>
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>2021</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Agrarpolitik 22+ abgelehnt
          </h4>
          <p>
            Nach monatelangen, heftigen Diskussionen lehnt das Parlament auf
            Druck des Bauernverbandes die neue Agrarpolitik 22+ des Bundesrats
            ab.
          </p>
          <h4
            className='vertical-timeline-element-subtitle'
            style={{ marginTop: '1rem' }}
          >
            Parlamentarische Initiative zu Pestiziden
          </h4>
          <p>
            Stattdessen verabschieden beide Kammern die Initiative «Risiko beim
            Einsatz von Pestiziden reduzieren» als indirekten Gegenvorschlag zu
            den beiden Agrarinitiativen.
          </p>
          <h4
            className='vertical-timeline-element-subtitle'
            style={{ marginTop: '1rem' }}
          >
            Abstimmung Trinkwasserinitiative, Pestizidinitiative
          </h4>
          <p>
            Schweizerinnen und Schweizer stimmen über die beiden
            Agrarinitiativen ab.
          </p>
          <div className='quote'>
            <p>
              «Um weniger Pflanzenschutzmittel zu gebrauchen, müssen wir: auf
              komplexe Anbausysteme setzen, die das Aufschaukeln von
              Schaderregern abbremsen; naturnahen Pflanzenschutz entwickeln, der
              auf eine ganz andere Palette von Wirkstoffen setzt, die der Natur
              abgeguckt sind; die Pflanzenzüchtung beschleunigen, sodass sich
              die Pflanzen gegen Schaderreger selber wehren können.
            </p>
            <p>
              Die Landwirtschaft wird noch viele Jahre brauchen, bis der
              chemische Pflanzenschutz überflüssig ist. Die zahlreichen
              Erkenntnisse aus der Umweltanalytik belegen, dass dies notwendig
              ist. Mit den beiden Initiativen schüttet man das Kind aber mit dem
              Bad aus.»
            </p>
            <div>
              <img
                className='ui medium circular image'
                src={require('../../images/urs-niggli.png')}
              />
              <span>Urs Niggli</span>
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  }
  // {
  //   step: (
  //     <>
  //       <VerticalTimelineElement
  //         className='vertical-timeline-element--work'
  //         contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
  //         contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
  //         date='2011 - present'
  //         iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
  //         icon={<i className='icon dot circle large green' />}
  //       >
  //         <h3 className='vertical-timeline-element-title'>16. Juni</h3>
  //         <h4 className='vertical-timeline-element-subtitle'>Lorem ipsum</h4>
  //         <p>
  //           Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
  //           nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
  //           erat, sed diam voluptua.
  //         </p>
  //       </VerticalTimelineElement>
  //     </>
  //   )
  // }
]
